<div class="flex-1 min-h-0 h-full overflow-auto px-[1.25rem] py-[1rem]"
     [formGroup]="form">
  <p-button [text]="true"
            severity="contrast"
            class="mb-[1rem] flex"
            styleClass="!gap-[0.35rem] !px-0 !py-0 !text-[0.75rem] !font-semibold !text-(--p-primary-500) !border-none hover:!text-(--p-sky-500)"
            (onClick)="cancel()">
    <svg-icon src="icons/icon-arrow-left.svg" name="icon-arrow-left" class="size-[1.25rem] shrink-0"></svg-icon>

    <span [translate]="dialogState.isCreating() ? '@@fp-event-location-edit__back-to-create' : '@@fp-event-status-form__back'"></span>
  </p-button>

  <div class="px-4 py-3 bg-(--p-neutral-50) rounded-lg">
    <h3 class="text-[0.875rem] font-semibold leading-[150%] text-(--p-gray-950)">{{ '@@fp-event-location-edit__title' | translate }}</h3>

    <p class="mt-[1rem] text-[0.75rem] leading-[150%] text-(--p-gray-500)"
       translate="@@fp-event-location-edit__description"></p>

    <div class="mt-[1rem] flex flex-wrap items-center gap-[0.75rem] max-w-[28.75rem]">
      <span class="text-[0.6875rem] font-medium text-(--p-gray-600) shrink-0"
            translate="@@fp-event-location-edit__location-label"></span>

      <gc-address-search class="min-w-[16rem] flex-1"
                         formControlName="location"
                         [placeholder]="pinEdit.isLargeMove() ? '@@fp-event-location-edit__press-checkmark' : '@@fp-event-address__placeholder'"
                         (addressSelected)="onAddressSelected($event)"></gc-address-search>
    </div>

    <div class="relative mt-[1rem] h-[15.75rem] overflow-hidden rounded-[0.5rem] max-w-[28.75rem]">
      <!-- the map draws what `DialogEventLocationMapService` gives it -->
      <gc-map-wrapper class="size-full"></gc-map-wrapper>

      @if (pinEdit.isLargeMove()) {
        <gc-map-edit-toolbar class="absolute left-1/2 top-[0.75rem] z-content-overlay-10 max-w-[calc(100%-1.5rem)] -translate-x-1/2"
                             iconSrc="icons/icon-event-change-position.svg"
                             [hasChanges]="true"
                             [disabled]="pinEdit.isResolving()"
                             (undo)="pinEdit.undo()"
                             (closed)="pinEdit.cancelMove()"
                             (confirmed)="pinEdit.confirmMove()">
          <span class="truncate text-[0.6875rem] font-medium text-(--p-white) opacity-80" translate="@@fp-event-location-edit__title"></span>
        </gc-map-edit-toolbar>
      }
    </div>

    <div class="mt-[1rem] flex flex-wrap gap-x-[2rem] gap-y-[0.375rem]">
      <div class="flex items-center gap-[0.5rem] text-[0.75rem] leading-[150%]">
        <span class="text-(--p-gray-500)" translate="@@shared-latitude__text"></span>

        <span class="font-semibold text-(--p-gray-950)">{{ latitude() }}</span>
      </div>

      <div class="flex items-center gap-[0.5rem] text-[0.75rem] leading-[150%]">
        <span class="text-(--p-gray-500)" translate="@@shared-longitude__text"></span>

        <span class="font-semibold text-(--p-gray-950)">{{ longitude() }}</span>
      </div>
    </div>

    <div class="mt-[0.75rem] flex items-start gap-[0.5rem] text-[0.75rem] leading-[150%]">
      <span class="shrink-0 text-(--p-gray-500)" translate="@@fp-event-location-edit__address-label"></span>

      @if (pinEdit.isLargeMove()) {
        <span class="text-(--p-gray-300)" translate="@@fp-event-location-edit__press-checkmark"></span>
      } @else {
        <span class="font-semibold text-(--p-gray-950)">{{ location() || ('@@shared-no-data-value-placeholder' | translate) }}</span>
      }
    </div>
  </div>
</div>

<div class="flex shrink-0 flex-col items-center gap-[0.75rem] border-t border-t-(--p-primary-50) px-[1.25rem] py-[0.875rem] sm:flex-row sm:flex-wrap sm:justify-between">
  <span class="text-[0.6875rem] leading-[150%] text-(--p-gray-500)"
        translate="@@fp-event-location-edit__not-saved-hint"></span>

  <div class="flex items-center gap-[0.25rem]">
    <p-button [outlined]="true"
              styleClass="!h-[2rem] !px-[1rem] !rounded-[0.25rem] !border-(--p-primary-500) !text-(--p-primary-500)"
              [label]="'@@shared-cancel__text' | translate"
              (onClick)="cancel()"></p-button>

    <p-button styleClass="!h-[2rem] !px-[1rem] !rounded-[0.25rem]"
              [label]="'@@fp-event-location-edit__save' | translate"
              [disabled]="!canSave()"
              [loading]="dialogState.isSaving()"
              (onClick)="save()"></p-button>
  </div>
</div>
